export default {
  text: {
    order_cancelled: 'Bestellung storniert - Fahrer nicht verfügbar',
    wolt_support: 'Fragen? Ruf direkt Wolt an <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>DRINGEND:</strong> Bitte akzeptiere oder lehne diese Bestellung sofort ab',
    no_driver_found: '<strong>Kein Fahrer gefunden.</strong> Liefere die Bestellung selbst aus oder storniere sie',
  },
  labels: {
    dummy_order: 'Test Bestellung',
    items_one: '{{count}} Produkt',
    items_other: '{{count}} Produkte',
    needs_acceptance: 'Akzeptanz erforderlich',
    driver_pending: 'Warten auf Fahrer',
    driver_search_retrying: 'Fahrer wird weiter gesucht',
    no_driver_found: 'Kein Fahrer gefunden',
    today: 'Heute',
    driver_assigned: 'Fahrer zugewiesen',
    complete: 'Abgeschlossen',
  },
  buttons: {
    complete_order: 'Als erledigt markieren',
    looking_for_driver: 'Suchen nach Fahrer...',
    click_to_remove: 'Anklicken zum Entfernen',
  },
};
